import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <Layout>
        <Component {...props} user={rest.user} />
      </Layout>
    )}
  />
);

AppRoute.propTypes = {
  component: PropTypes.instanceOf(Object).isRequired,
  layout: PropTypes.instanceOf(Object).isRequired,
};

export default AppRoute;
